import { apiGet, apiPost, apiPut, apiDelete } from '@ibkr/clientportal.common/src/api/default'
import { isString } from '@ibkr/clientportal.common/src/js/string'
import { PortalBaseUrl } from '@ibkr/clientportal.common/src/js/portalBaseUrl.js'
import requester from '@ibkr/web.app.request.util'

const base = '';
const isQA = process.env.BUILD_ENV == 'build.qa' || window.env == 'qa';

function getCompanyLogo(conid) {
    return apiGet(base + '/benzinga/logos?conid=' + conid);
}

function getAllBalancesSummary(acctIds) {
    return apiPost(base + '/pa/summary', { acctIds: acctIds });
}

function getCloudRead({ scanners = undefined, filename = undefined, portal = undefined, ext = undefined}) {
    let query = '';
    if (scanners) {
        query += 'scanners=1';
    }
    if (filename) {
        query += 'filename=portal.' + filename;
    }
    if (portal) {
        query += 'portal=1';
    }
    if (ext && portal) {
        query += '&ext=' + ext;
    }
    return apiGet(base + '/wlms/cloud/read' + (query ? '?' + query : ''));
}

function getCloudStore(md5base64 = '', ext = '', binary = true) {
    let query = '?';
    if (md5base64) {
        query += 'md5base64=' + md5base64;
    }
    if (ext) {
        query += '&ext=' + ext;
    }
    if (binary) {
        query += '&bin=' + binary;
    }
    return apiGet(base + '/wlms/cloud/store' + query);
}

function getCloudDelete(ext = '') {
    let query = '';
    if (ext) {
        query = '?ext=' + ext;
    }
    return apiGet(base + '/wlms/cloud/delete' + query);
}

function getCompetitors() {
    return apiGet(base + '/portfolio/competitors');
}

function getFundamentals(conid) {
    if (isNaN(conid)) {
        return;
    }
    return apiGet(base + '/iserver/fundamentals/' + conid + '/summary');
}

function getMarketDataSubscriptions() {
    return apiGet(base + '/ibcust/marketdata/subscriptions');
}

function getPortfolioNews() {
    return apiGet(base + '/iserver/news/portfolio');
}

function getSearchBySym(sym) {
    return apiPost('/iserver/secdef/search', {'symbol': sym});
}

function getSecdefInfo(conid) {
    return apiGet('/iserver/secdef/info?conid=' + conid);
}

function getSecdefs(conids, contracts=false) {
    if (conids == undefined || conids.length == 0) {
        return Promise.reject("getSecdefs: empty conids");
    } else {
        return apiGet(`/trsrv/secdef?conids=${conids.join(',')}&contracts=${contracts}`);
    }
}

function getSecdefSchedule(assetClass, symbol, exchange) {
    return apiGet(`/trsrv/secdef/schedule?assetClass=${assetClass}&symbol=${symbol}&exchangeFilter=${exchange}`);
}

function getConidsByExchange(exchange) {
    if (!exchange) {
        return Promise.reject("getConidsByExchange: Exchange not specified");
    } else {
        return apiGet(`/trsrv/all-conids?exchange=${exchange}`);
    }
}

function getBriefingArticle() {
    return apiGet(base + '/iserver/news/briefing');
}

function getTopNews() {
    return apiGet(base + '/iserver/news/top');
}

function getNewsSources() {
    return apiGet(base + '/iserver/news/sources');
}

function getNews(conid, lastNewsId) {
    if (isNaN(conid)) {
        return;
    }
    return lastNewsId ? apiGet(base + '/iserver/news?conid=' + conid + '&more=' + lastNewsId) :
        apiGet(base + '/iserver/news?conid=' + conid);
}

function getNewsContent(newsId) {
    return apiGet(base + '/iserver/news/' + newsId + '/content');
}

function getTrades(acctIds) {
    return apiGet(base + '/iserver/account/trades', acctIds );
}

function getPerformanceData(acctIds, period='12M', benchmarks=[], consolidate='none') {
    return apiPost(base + '/pa/performance', { acctIds, period, benchmarks, consolidate });
}

function getPerformanceAllPeriods(acctIds, model, benchmarks=[]) {
    return apiPost(base + '/pa/allperiods', { acctIds: acctIds, model: model, benchmarks: benchmarks});
}

function getTransactions({ acctIds, days, currency, conids, additional = null }) {
    return apiPost(base + '/pa/transactions', { acctIds, days, currency, conids, additional });
}

function getAcctPnl(acctId) {
    return apiGet(base + '/iserver/account/' + acctId + '/pnl');
}

export const validateSso = () => {
    return apiGet(base + '/sso/validate');
}

function getMarketIndices() {
    return apiGet(base + '/markets/indices');
}

function getTimeInForceTypes() {
    return apiGet(base + '/one/order/tifs');
}

function logout() {
    return apiPost(base + '/logout');
}

function tickleSession() {
    return apiPost(base + '/tickle');
}

function ssoLogout() {
    return apiPost('/sso/Logout');
}

function postOrderPreview(acctId, order) {
    return apiPost(base + '/iserver/account/' + acctId +'/order/whatif', order);
}

function ssoDHresponse(response) {
    return apiPost(base + '/iserver/auth/ssodh/response', { response: response });
}

function autologon() {
    return apiPost(base + '/iserver/auth/autologon');
}

function getMktAm(id) {
    return fetch('https://' + process.env.WB_DOMAIN + '/mkt/am.php?id=' + id)
        .then(res => res.text())
        .then(str => (new window.DOMParser()).parseFromString(str, 'text/xml'));
}

function getFutureContracts(symbols) {
    return apiGet(base + '/trsrv/futures?symbols=' + symbols);
}

function getStockContracts(symbols) {
    return apiGet(base + '/trsrv/stocks?symbols=' + symbols);
}

function getReutersSections(conid) {
    return apiGet(base + '/reuters/sections?conid=' + conid);
}

function getAccountProperties(accountIds) {
    return apiPost(base + '/properties', { accountIds });
}

function getSbuzzData(conid) {
    let url;
    if (isQA) {
        url = process.env.BRAND_BASE_URL  + '/tws.proxy/sma/request?type=latest&conid=' + conid;
    } else {
        url = 'sma/request?type=latest&conid=' + conid;
    }

    return new Promise((resolve, reject) => {
        requester.request(url, { })
            .then((r) => r.json())
            .then(res => resolve(res))
            .catch((err) => {
                reject(err);
            });
    });
}

function sendTelemetry(data) {
    const body = JSON.stringify(data);
    let url;
    if (isQA) {
        url = process.env.BRAND_BASE_URL  + '/tws.proxy/telemetry/authAdd';
    } else {
        url = 'telemetry/authAdd';
    }
    if (url) {
        requester.request(url, {
            method: 'POST',
            body: body
        });
    }
}

function getImpactPosition(conid, accounts) {
    let url = `impact/portfolio/position?conid=${conid}&accounts=${accounts}&short=false`;
    if (isQA) {
        url = process.env.BRAND_BASE_URL  + '/tws.proxy/' + url;
    }

    return new Promise((resolve, reject) => {
        requester.request(url, { })
            .then((r) => r.json())
            .then(res => resolve(res))
            .catch((err) => {
                reject(err);
            });
    });
}

const cmnApi = {
    autologon,
    getAllBalancesSummary,
    getCloudRead,
    getCloudStore,
    getCloudDelete,
    getCompanyLogo,
    getCompetitors,
    getFundamentals,
    getMktAm,
    getAcctPnl,
    getMarketDataSubscriptions,
    getNews,
    getPortfolioNews,
    getNewsSources,
    getBriefingArticle,
    getTopNews,
    getNewsContent,
    getPerformanceData,
    getPerformanceAllPeriods,
    getTransactions,
    getMarketIndices,
    getSearchBySym,
    getSecdefInfo,
    getSecdefs,
    getSecdefSchedule,
    getTimeInForceTypes,
    getTrades,
    logout,
    postOrderPreview,
    ssoDHresponse,
    validateSso,
    getFutureContracts,
    getStockContracts,
    tickleSession,
    apiGet,
    getSbuzzData,
    apiPut,
    apiPost,
    apiDelete,
    getReutersSections,
    getAccountProperties,
    sendTelemetry,
    getImpactPosition,
    getConidsByExchange
}

export default cmnApi;

window.cmnApi = cmnApi;
